const ACCESS_KEY = '@pagaagro/access-token';
const REFRESH_KEY = '@pagaagro/refresh-token';

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS_KEY);
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function saveAccessToken(token: string): void {
  try {
    localStorage.setItem(ACCESS_KEY, token);
  } catch {
  }
}

export function saveRefreshToken(token: string): void {
  try {
    localStorage.setItem(REFRESH_KEY, token);
  } catch {
  }
}

export function removeTokens(): void {
  try {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  } catch {
  }
}
